/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AggregationWindow } from '../models';
// @ts-ignore
import type { DashboardMetricType } from '../models';
// @ts-ignore
import type { DashboardViewType } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { SingleUsageResponse } from '../models';
// @ts-ignore
import type { UsageAggregatedResponse } from '../models';
// @ts-ignore
import type { UsageByAgentResponse } from '../models';
// @ts-ignore
import type { UsageDashboardResponse } from '../models';
/**
 * AnalyticsUsageApi - axios parameter creator
 * @export
 */
export const AnalyticsUsageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve aggregated call usage metrics for a specified time range. Supports hourly, daily, and weekly aggregation windows. Optionally filter by agent_id. Maximum time range is 90 days. Requires \'analytics:view\' permission.
         * @summary Get aggregated usage metrics
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for metrics
         * @param {string | null} [agentId] Agent ID to filter by (optional)
         * @param {string | null} [organizationId] Organization ID to filter by (optional, admin only)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedMetricsApiV1AnalyticsUsageAggregateGet: async (startTime: string, endTime: string, window?: AggregationWindow, agentId?: string | null, organizationId?: string | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getAggregatedMetricsApiV1AnalyticsUsageAggregateGet', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('getAggregatedMetricsApiV1AnalyticsUsageAggregateGet', 'endTime', endTime)
            const localVarPath = `/api/v1/analytics/usage/aggregate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (window !== undefined) {
                localVarQueryParameter['window'] = window;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organization_id'] = organizationId;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve aggregated call usage metrics for a specified time range. Supports hourly, daily, and weekly aggregation windows. Optionally filter by agent_id. Maximum time range is 90 days. Requires \'analytics:view\' permission.
         * @summary Get aggregated usage metrics
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for metrics
         * @param {string | null} [agentId] Agent ID to filter by (optional)
         * @param {string | null} [organizationId] Organization ID to filter by (optional, admin only)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedMetricsApiV1AnalyticsUsageAggregateGet_1: async (startTime: string, endTime: string, window?: AggregationWindow, agentId?: string | null, organizationId?: string | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getAggregatedMetricsApiV1AnalyticsUsageAggregateGet_1', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('getAggregatedMetricsApiV1AnalyticsUsageAggregateGet_1', 'endTime', endTime)
            const localVarPath = `/api/v1/analytics/usage/aggregate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (window !== undefined) {
                localVarQueryParameter['window'] = window;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organization_id'] = organizationId;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve call usage analytics for dashboard visualization. Supports daily (24 hourly buckets), weekly (7 daily buckets), and monthly (30 daily buckets) views. Optionally filter by agent_id. Requires \'analytics:view\' permission.
         * @summary Get usage dashboard analytics
         * @param {DashboardViewType} viewType Time window: \&#39;daily\&#39; (last 24 hours), \&#39;weekly\&#39; (last 7 days), or \&#39;monthly\&#39; (last 30 days)
         * @param {DashboardMetricType} metric Metric: \&#39;count\&#39; (number of calls) or \&#39;duration\&#39; (total seconds)
         * @param {string | null} [agentId] Agent ID to filter by (optional)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardApiV1AnalyticsUsageDashboardGet: async (viewType: DashboardViewType, metric: DashboardMetricType, agentId?: string | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'viewType' is not null or undefined
            assertParamExists('getDashboardApiV1AnalyticsUsageDashboardGet', 'viewType', viewType)
            // verify required parameter 'metric' is not null or undefined
            assertParamExists('getDashboardApiV1AnalyticsUsageDashboardGet', 'metric', metric)
            const localVarPath = `/api/v1/analytics/usage/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (viewType !== undefined) {
                localVarQueryParameter['view_type'] = viewType;
            }

            if (metric !== undefined) {
                localVarQueryParameter['metric'] = metric;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve call usage analytics for dashboard visualization. Supports daily (24 hourly buckets), weekly (7 daily buckets), and monthly (30 daily buckets) views. Optionally filter by agent_id. Requires \'analytics:view\' permission.
         * @summary Get usage dashboard analytics
         * @param {DashboardViewType} viewType Time window: \&#39;daily\&#39; (last 24 hours), \&#39;weekly\&#39; (last 7 days), or \&#39;monthly\&#39; (last 30 days)
         * @param {DashboardMetricType} metric Metric: \&#39;count\&#39; (number of calls) or \&#39;duration\&#39; (total seconds)
         * @param {string | null} [agentId] Agent ID to filter by (optional)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardApiV1AnalyticsUsageDashboardGet_2: async (viewType: DashboardViewType, metric: DashboardMetricType, agentId?: string | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'viewType' is not null or undefined
            assertParamExists('getDashboardApiV1AnalyticsUsageDashboardGet_2', 'viewType', viewType)
            // verify required parameter 'metric' is not null or undefined
            assertParamExists('getDashboardApiV1AnalyticsUsageDashboardGet_2', 'metric', metric)
            const localVarPath = `/api/v1/analytics/usage/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (viewType !== undefined) {
                localVarQueryParameter['view_type'] = viewType;
            }

            if (metric !== undefined) {
                localVarQueryParameter['metric'] = metric;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve detailed metrics for a single usage record. Requires \'analytics:view\' permission.
         * @summary Get single usage record
         * @param {string} usageId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSingleUsageApiV1AnalyticsUsageUsageIdGet: async (usageId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'usageId' is not null or undefined
            assertParamExists('getSingleUsageApiV1AnalyticsUsageUsageIdGet', 'usageId', usageId)
            const localVarPath = `/api/v1/analytics/usage/{usage_id}`
                .replace(`{${"usage_id"}}`, encodeURIComponent(String(usageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve detailed metrics for a single usage record. Requires \'analytics:view\' permission.
         * @summary Get single usage record
         * @param {string} usageId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSingleUsageApiV1AnalyticsUsageUsageIdGet_3: async (usageId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'usageId' is not null or undefined
            assertParamExists('getSingleUsageApiV1AnalyticsUsageUsageIdGet_3', 'usageId', usageId)
            const localVarPath = `/api/v1/analytics/usage/{usage_id}`
                .replace(`{${"usage_id"}}`, encodeURIComponent(String(usageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve usage metrics broken down by agent. Shows call counts, token usage, and performance metrics per agent. Maximum time range is 90 days. Requires \'analytics:view\' permission.
         * @summary Get per-agent usage breakdown
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsageByAgentApiV1AnalyticsUsageAgentsGet: async (startTime: string, endTime: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getUsageByAgentApiV1AnalyticsUsageAgentsGet', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('getUsageByAgentApiV1AnalyticsUsageAgentsGet', 'endTime', endTime)
            const localVarPath = `/api/v1/analytics/usage/agents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve usage metrics broken down by agent. Shows call counts, token usage, and performance metrics per agent. Maximum time range is 90 days. Requires \'analytics:view\' permission.
         * @summary Get per-agent usage breakdown
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsageByAgentApiV1AnalyticsUsageAgentsGet_4: async (startTime: string, endTime: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getUsageByAgentApiV1AnalyticsUsageAgentsGet_4', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('getUsageByAgentApiV1AnalyticsUsageAgentsGet_4', 'endTime', endTime)
            const localVarPath = `/api/v1/analytics/usage/agents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnalyticsUsageApi - functional programming interface
 * @export
 */
export const AnalyticsUsageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnalyticsUsageApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve aggregated call usage metrics for a specified time range. Supports hourly, daily, and weekly aggregation windows. Optionally filter by agent_id. Maximum time range is 90 days. Requires \'analytics:view\' permission.
         * @summary Get aggregated usage metrics
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for metrics
         * @param {string | null} [agentId] Agent ID to filter by (optional)
         * @param {string | null} [organizationId] Organization ID to filter by (optional, admin only)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAggregatedMetricsApiV1AnalyticsUsageAggregateGet(startTime: string, endTime: string, window?: AggregationWindow, agentId?: string | null, organizationId?: string | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsageAggregatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAggregatedMetricsApiV1AnalyticsUsageAggregateGet(startTime, endTime, window, agentId, organizationId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsUsageApi.getAggregatedMetricsApiV1AnalyticsUsageAggregateGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve aggregated call usage metrics for a specified time range. Supports hourly, daily, and weekly aggregation windows. Optionally filter by agent_id. Maximum time range is 90 days. Requires \'analytics:view\' permission.
         * @summary Get aggregated usage metrics
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for metrics
         * @param {string | null} [agentId] Agent ID to filter by (optional)
         * @param {string | null} [organizationId] Organization ID to filter by (optional, admin only)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAggregatedMetricsApiV1AnalyticsUsageAggregateGet_1(startTime: string, endTime: string, window?: AggregationWindow, agentId?: string | null, organizationId?: string | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsageAggregatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAggregatedMetricsApiV1AnalyticsUsageAggregateGet_1(startTime, endTime, window, agentId, organizationId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsUsageApi.getAggregatedMetricsApiV1AnalyticsUsageAggregateGet_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve call usage analytics for dashboard visualization. Supports daily (24 hourly buckets), weekly (7 daily buckets), and monthly (30 daily buckets) views. Optionally filter by agent_id. Requires \'analytics:view\' permission.
         * @summary Get usage dashboard analytics
         * @param {DashboardViewType} viewType Time window: \&#39;daily\&#39; (last 24 hours), \&#39;weekly\&#39; (last 7 days), or \&#39;monthly\&#39; (last 30 days)
         * @param {DashboardMetricType} metric Metric: \&#39;count\&#39; (number of calls) or \&#39;duration\&#39; (total seconds)
         * @param {string | null} [agentId] Agent ID to filter by (optional)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardApiV1AnalyticsUsageDashboardGet(viewType: DashboardViewType, metric: DashboardMetricType, agentId?: string | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsageDashboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardApiV1AnalyticsUsageDashboardGet(viewType, metric, agentId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsUsageApi.getDashboardApiV1AnalyticsUsageDashboardGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve call usage analytics for dashboard visualization. Supports daily (24 hourly buckets), weekly (7 daily buckets), and monthly (30 daily buckets) views. Optionally filter by agent_id. Requires \'analytics:view\' permission.
         * @summary Get usage dashboard analytics
         * @param {DashboardViewType} viewType Time window: \&#39;daily\&#39; (last 24 hours), \&#39;weekly\&#39; (last 7 days), or \&#39;monthly\&#39; (last 30 days)
         * @param {DashboardMetricType} metric Metric: \&#39;count\&#39; (number of calls) or \&#39;duration\&#39; (total seconds)
         * @param {string | null} [agentId] Agent ID to filter by (optional)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardApiV1AnalyticsUsageDashboardGet_2(viewType: DashboardViewType, metric: DashboardMetricType, agentId?: string | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsageDashboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardApiV1AnalyticsUsageDashboardGet_2(viewType, metric, agentId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsUsageApi.getDashboardApiV1AnalyticsUsageDashboardGet_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve detailed metrics for a single usage record. Requires \'analytics:view\' permission.
         * @summary Get single usage record
         * @param {string} usageId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSingleUsageApiV1AnalyticsUsageUsageIdGet(usageId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleUsageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSingleUsageApiV1AnalyticsUsageUsageIdGet(usageId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsUsageApi.getSingleUsageApiV1AnalyticsUsageUsageIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve detailed metrics for a single usage record. Requires \'analytics:view\' permission.
         * @summary Get single usage record
         * @param {string} usageId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSingleUsageApiV1AnalyticsUsageUsageIdGet_3(usageId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleUsageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSingleUsageApiV1AnalyticsUsageUsageIdGet_3(usageId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsUsageApi.getSingleUsageApiV1AnalyticsUsageUsageIdGet_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve usage metrics broken down by agent. Shows call counts, token usage, and performance metrics per agent. Maximum time range is 90 days. Requires \'analytics:view\' permission.
         * @summary Get per-agent usage breakdown
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsageByAgentApiV1AnalyticsUsageAgentsGet(startTime: string, endTime: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsageByAgentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsageByAgentApiV1AnalyticsUsageAgentsGet(startTime, endTime, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsUsageApi.getUsageByAgentApiV1AnalyticsUsageAgentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve usage metrics broken down by agent. Shows call counts, token usage, and performance metrics per agent. Maximum time range is 90 days. Requires \'analytics:view\' permission.
         * @summary Get per-agent usage breakdown
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsageByAgentApiV1AnalyticsUsageAgentsGet_4(startTime: string, endTime: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsageByAgentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsageByAgentApiV1AnalyticsUsageAgentsGet_4(startTime, endTime, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsUsageApi.getUsageByAgentApiV1AnalyticsUsageAgentsGet_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AnalyticsUsageApi - factory interface
 * @export
 */
export const AnalyticsUsageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnalyticsUsageApiFp(configuration)
    return {
        /**
         * Retrieve aggregated call usage metrics for a specified time range. Supports hourly, daily, and weekly aggregation windows. Optionally filter by agent_id. Maximum time range is 90 days. Requires \'analytics:view\' permission.
         * @summary Get aggregated usage metrics
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for metrics
         * @param {string | null} [agentId] Agent ID to filter by (optional)
         * @param {string | null} [organizationId] Organization ID to filter by (optional, admin only)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedMetricsApiV1AnalyticsUsageAggregateGet(startTime: string, endTime: string, window?: AggregationWindow, agentId?: string | null, organizationId?: string | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<UsageAggregatedResponse> {
            return localVarFp.getAggregatedMetricsApiV1AnalyticsUsageAggregateGet(startTime, endTime, window, agentId, organizationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve aggregated call usage metrics for a specified time range. Supports hourly, daily, and weekly aggregation windows. Optionally filter by agent_id. Maximum time range is 90 days. Requires \'analytics:view\' permission.
         * @summary Get aggregated usage metrics
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for metrics
         * @param {string | null} [agentId] Agent ID to filter by (optional)
         * @param {string | null} [organizationId] Organization ID to filter by (optional, admin only)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregatedMetricsApiV1AnalyticsUsageAggregateGet_1(startTime: string, endTime: string, window?: AggregationWindow, agentId?: string | null, organizationId?: string | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<UsageAggregatedResponse> {
            return localVarFp.getAggregatedMetricsApiV1AnalyticsUsageAggregateGet_1(startTime, endTime, window, agentId, organizationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve call usage analytics for dashboard visualization. Supports daily (24 hourly buckets), weekly (7 daily buckets), and monthly (30 daily buckets) views. Optionally filter by agent_id. Requires \'analytics:view\' permission.
         * @summary Get usage dashboard analytics
         * @param {DashboardViewType} viewType Time window: \&#39;daily\&#39; (last 24 hours), \&#39;weekly\&#39; (last 7 days), or \&#39;monthly\&#39; (last 30 days)
         * @param {DashboardMetricType} metric Metric: \&#39;count\&#39; (number of calls) or \&#39;duration\&#39; (total seconds)
         * @param {string | null} [agentId] Agent ID to filter by (optional)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardApiV1AnalyticsUsageDashboardGet(viewType: DashboardViewType, metric: DashboardMetricType, agentId?: string | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<UsageDashboardResponse> {
            return localVarFp.getDashboardApiV1AnalyticsUsageDashboardGet(viewType, metric, agentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve call usage analytics for dashboard visualization. Supports daily (24 hourly buckets), weekly (7 daily buckets), and monthly (30 daily buckets) views. Optionally filter by agent_id. Requires \'analytics:view\' permission.
         * @summary Get usage dashboard analytics
         * @param {DashboardViewType} viewType Time window: \&#39;daily\&#39; (last 24 hours), \&#39;weekly\&#39; (last 7 days), or \&#39;monthly\&#39; (last 30 days)
         * @param {DashboardMetricType} metric Metric: \&#39;count\&#39; (number of calls) or \&#39;duration\&#39; (total seconds)
         * @param {string | null} [agentId] Agent ID to filter by (optional)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardApiV1AnalyticsUsageDashboardGet_2(viewType: DashboardViewType, metric: DashboardMetricType, agentId?: string | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<UsageDashboardResponse> {
            return localVarFp.getDashboardApiV1AnalyticsUsageDashboardGet_2(viewType, metric, agentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve detailed metrics for a single usage record. Requires \'analytics:view\' permission.
         * @summary Get single usage record
         * @param {string} usageId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSingleUsageApiV1AnalyticsUsageUsageIdGet(usageId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<SingleUsageResponse> {
            return localVarFp.getSingleUsageApiV1AnalyticsUsageUsageIdGet(usageId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve detailed metrics for a single usage record. Requires \'analytics:view\' permission.
         * @summary Get single usage record
         * @param {string} usageId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSingleUsageApiV1AnalyticsUsageUsageIdGet_3(usageId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<SingleUsageResponse> {
            return localVarFp.getSingleUsageApiV1AnalyticsUsageUsageIdGet_3(usageId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve usage metrics broken down by agent. Shows call counts, token usage, and performance metrics per agent. Maximum time range is 90 days. Requires \'analytics:view\' permission.
         * @summary Get per-agent usage breakdown
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsageByAgentApiV1AnalyticsUsageAgentsGet(startTime: string, endTime: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<UsageByAgentResponse> {
            return localVarFp.getUsageByAgentApiV1AnalyticsUsageAgentsGet(startTime, endTime, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve usage metrics broken down by agent. Shows call counts, token usage, and performance metrics per agent. Maximum time range is 90 days. Requires \'analytics:view\' permission.
         * @summary Get per-agent usage breakdown
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsageByAgentApiV1AnalyticsUsageAgentsGet_4(startTime: string, endTime: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<UsageByAgentResponse> {
            return localVarFp.getUsageByAgentApiV1AnalyticsUsageAgentsGet_4(startTime, endTime, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnalyticsUsageApi - object-oriented interface
 * @export
 * @class AnalyticsUsageApi
 * @extends {BaseAPI}
 */
export class AnalyticsUsageApi extends BaseAPI {
    /**
     * Retrieve aggregated call usage metrics for a specified time range. Supports hourly, daily, and weekly aggregation windows. Optionally filter by agent_id. Maximum time range is 90 days. Requires \'analytics:view\' permission.
     * @summary Get aggregated usage metrics
     * @param {string} startTime Start time in ISO 8601 format (UTC)
     * @param {string} endTime End time in ISO 8601 format (UTC)
     * @param {AggregationWindow} [window] Aggregation window for metrics
     * @param {string | null} [agentId] Agent ID to filter by (optional)
     * @param {string | null} [organizationId] Organization ID to filter by (optional, admin only)
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsUsageApi
     */
    public getAggregatedMetricsApiV1AnalyticsUsageAggregateGet(startTime: string, endTime: string, window?: AggregationWindow, agentId?: string | null, organizationId?: string | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return AnalyticsUsageApiFp(this.configuration).getAggregatedMetricsApiV1AnalyticsUsageAggregateGet(startTime, endTime, window, agentId, organizationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve aggregated call usage metrics for a specified time range. Supports hourly, daily, and weekly aggregation windows. Optionally filter by agent_id. Maximum time range is 90 days. Requires \'analytics:view\' permission.
     * @summary Get aggregated usage metrics
     * @param {string} startTime Start time in ISO 8601 format (UTC)
     * @param {string} endTime End time in ISO 8601 format (UTC)
     * @param {AggregationWindow} [window] Aggregation window for metrics
     * @param {string | null} [agentId] Agent ID to filter by (optional)
     * @param {string | null} [organizationId] Organization ID to filter by (optional, admin only)
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsUsageApi
     */
    public getAggregatedMetricsApiV1AnalyticsUsageAggregateGet_1(startTime: string, endTime: string, window?: AggregationWindow, agentId?: string | null, organizationId?: string | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return AnalyticsUsageApiFp(this.configuration).getAggregatedMetricsApiV1AnalyticsUsageAggregateGet_1(startTime, endTime, window, agentId, organizationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve call usage analytics for dashboard visualization. Supports daily (24 hourly buckets), weekly (7 daily buckets), and monthly (30 daily buckets) views. Optionally filter by agent_id. Requires \'analytics:view\' permission.
     * @summary Get usage dashboard analytics
     * @param {DashboardViewType} viewType Time window: \&#39;daily\&#39; (last 24 hours), \&#39;weekly\&#39; (last 7 days), or \&#39;monthly\&#39; (last 30 days)
     * @param {DashboardMetricType} metric Metric: \&#39;count\&#39; (number of calls) or \&#39;duration\&#39; (total seconds)
     * @param {string | null} [agentId] Agent ID to filter by (optional)
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsUsageApi
     */
    public getDashboardApiV1AnalyticsUsageDashboardGet(viewType: DashboardViewType, metric: DashboardMetricType, agentId?: string | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return AnalyticsUsageApiFp(this.configuration).getDashboardApiV1AnalyticsUsageDashboardGet(viewType, metric, agentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve call usage analytics for dashboard visualization. Supports daily (24 hourly buckets), weekly (7 daily buckets), and monthly (30 daily buckets) views. Optionally filter by agent_id. Requires \'analytics:view\' permission.
     * @summary Get usage dashboard analytics
     * @param {DashboardViewType} viewType Time window: \&#39;daily\&#39; (last 24 hours), \&#39;weekly\&#39; (last 7 days), or \&#39;monthly\&#39; (last 30 days)
     * @param {DashboardMetricType} metric Metric: \&#39;count\&#39; (number of calls) or \&#39;duration\&#39; (total seconds)
     * @param {string | null} [agentId] Agent ID to filter by (optional)
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsUsageApi
     */
    public getDashboardApiV1AnalyticsUsageDashboardGet_2(viewType: DashboardViewType, metric: DashboardMetricType, agentId?: string | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return AnalyticsUsageApiFp(this.configuration).getDashboardApiV1AnalyticsUsageDashboardGet_2(viewType, metric, agentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve detailed metrics for a single usage record. Requires \'analytics:view\' permission.
     * @summary Get single usage record
     * @param {string} usageId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsUsageApi
     */
    public getSingleUsageApiV1AnalyticsUsageUsageIdGet(usageId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AnalyticsUsageApiFp(this.configuration).getSingleUsageApiV1AnalyticsUsageUsageIdGet(usageId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve detailed metrics for a single usage record. Requires \'analytics:view\' permission.
     * @summary Get single usage record
     * @param {string} usageId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsUsageApi
     */
    public getSingleUsageApiV1AnalyticsUsageUsageIdGet_3(usageId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AnalyticsUsageApiFp(this.configuration).getSingleUsageApiV1AnalyticsUsageUsageIdGet_3(usageId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve usage metrics broken down by agent. Shows call counts, token usage, and performance metrics per agent. Maximum time range is 90 days. Requires \'analytics:view\' permission.
     * @summary Get per-agent usage breakdown
     * @param {string} startTime Start time in ISO 8601 format (UTC)
     * @param {string} endTime End time in ISO 8601 format (UTC)
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsUsageApi
     */
    public getUsageByAgentApiV1AnalyticsUsageAgentsGet(startTime: string, endTime: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AnalyticsUsageApiFp(this.configuration).getUsageByAgentApiV1AnalyticsUsageAgentsGet(startTime, endTime, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve usage metrics broken down by agent. Shows call counts, token usage, and performance metrics per agent. Maximum time range is 90 days. Requires \'analytics:view\' permission.
     * @summary Get per-agent usage breakdown
     * @param {string} startTime Start time in ISO 8601 format (UTC)
     * @param {string} endTime End time in ISO 8601 format (UTC)
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsUsageApi
     */
    public getUsageByAgentApiV1AnalyticsUsageAgentsGet_4(startTime: string, endTime: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AnalyticsUsageApiFp(this.configuration).getUsageByAgentApiV1AnalyticsUsageAgentsGet_4(startTime, endTime, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

